export default "__VITE_ASSET__IfephY9b__"